import styled from 'styled-components';
import { IonHeader } from '@ionic/react';

const IonHeaderStyled = styled(IonHeader)`
  background: white;
`;

export { IonHeaderStyled };
